import { render, staticRenderFns } from "./LayerHost.vue?vue&type=template&id=0fba038e&scoped=true"
import script from "./LayerHost.vue?vue&type=script&lang=js"
export * from "./LayerHost.vue?vue&type=script&lang=js"
import style0 from "./LayerHost.vue?vue&type=style&index=0&id=0fba038e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba038e",
  null
  
)

export default component.exports